import mcheyneData from '../data/mcheyne.json';
import esvData from '../data/esvthroughthebible.json';
import chronoData from '../data/oneyearchronological.json';

export const PLANS = [
  {
    id: 'mcheyne',
    name: "M'Cheyne One-Year",
    description: '4 readings per day',
    detail: 'Two OT + two NT passages daily',
    data: mcheyneData,
  },
  {
    id: 'esvthroughthebible',
    name: 'Through the Bible',
    description: '2 readings per day',
    detail: 'OT + NT read in parallel',
    data: esvData,
  },
  {
    id: 'oneyearchronological',
    name: 'One Year Chronological',
    description: '1 reading per day',
    detail: 'Bible in historical order',
    data: chronoData,
  },
];

// Map reading-plan book name variants → en.json canonical names
const BOOK_NAME_MAP = {
  '1Samuel': '1 Samuel',       '2Samuel': '2 Samuel',
  '1Kings': '1 Kings',         '2Kings': '2 Kings',
  '1Chronicles': '1 Chronicles', '2Chronicles': '2 Chronicles',
  '1Corinthians': '1 Corinthians', '2Corinthians': '2 Corinthians',
  '1Thessalonians': '1 Thessalonians', '2Thessalonians': '2 Thessalonians',
  '1 Thes': '1 Thessalonians', '2 Thes': '2 Thessalonians',
  '1Timothy': '1 Timothy',     '2Timothy': '2 Timothy',
  '1Peter': '1 Peter',         '2Peter': '2 Peter',
  '1John': '1 John',           '2John': '2 John',    '3John': '3 John',
  'SongOfSongs': 'Song of Solomon',
  'Psalm': 'Psalms',
  'JONAH': 'Jonah', 'JOEL': 'Joel', 'OBADIAH': 'Obadiah',
};

// Ordered book names matching en.json / bibleData array indices
export const BIBLE_BOOKS = [
  'Genesis', 'Exodus', 'Leviticus', 'Numbers', 'Deuteronomy',
  'Joshua', 'Judges', 'Ruth', '1 Samuel', '2 Samuel',
  '1 Kings', '2 Kings', '1 Chronicles', '2 Chronicles',
  'Ezra', 'Nehemiah', 'Esther', 'Job', 'Psalms', 'Proverbs',
  'Ecclesiastes', 'Song of Solomon', 'Isaiah', 'Jeremiah',
  'Lamentations', 'Ezekiel', 'Daniel', 'Hosea', 'Joel', 'Amos',
  'Obadiah', 'Jonah', 'Micah', 'Nahum', 'Habakkuk', 'Zephaniah',
  'Haggai', 'Zechariah', 'Malachi', 'Matthew', 'Mark', 'Luke',
  'John', 'Acts', 'Romans', '1 Corinthians', '2 Corinthians',
  'Galatians', 'Ephesians', 'Philippians', 'Colossians',
  '1 Thessalonians', '2 Thessalonians', '1 Timothy', '2 Timothy',
  'Titus', 'Philemon', 'Hebrews', 'James', '1 Peter', '2 Peter',
  '1 John', '2 John', '3 John', 'Jude', 'Revelation',
];

function normalizeBookName(raw) {
  return BOOK_NAME_MAP[raw] || raw;
}

/**
 * Parse a passage string like "Genesis 1-2", "Psalm 119:1-88", "1 Thes 1-5"
 * into { book, chapter, bookIndex, chapterIndex }.
 * Returns null if unparseable or book not found.
 */
export function parsePassage(str) {
  const trimmed = str.trim();
  // Match: everything up to the last letter, then space, then digits
  const m = trimmed.match(/^(.*[a-zA-Z])\s+(\d+)/);
  if (!m) return null;
  const book = normalizeBookName(m[1].trim());
  const chapter = parseInt(m[2], 10);
  const bookIndex = BIBLE_BOOKS.indexOf(book);
  if (bookIndex === -1) return null;
  return { book, chapter, bookIndex, chapterIndex: chapter - 1 };
}

/** Returns today as 'YYYY-MM-DD' in the user's local timezone. */
export function getTodayString() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Returns 0-based day index from startDate string to today, clamped to 0–364. */
export function getDayIndex(startDate) {
  // Parse as local midnight (not UTC) to avoid timezone off-by-one
  const [y, m, d] = startDate.split('-').map(Number);
  const start = new Date(y, m - 1, d);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = Math.floor((today - start) / 86400000);
  return Math.max(0, Math.min(364, diff));
}

/** Count consecutive completed days ending at today's index. */
export function getStreak(completedDays, startDate) {
  if (!completedDays || completedDays.length === 0) return 0;
  const todayIdx = getDayIndex(startDate);
  const set = new Set(completedDays);
  let streak = 0;
  for (let i = todayIdx; i >= 0; i--) {
    if (set.has(i)) streak++;
    else break;
  }
  return streak;
}

const STORAGE_KEY = 'plutobible-reading-plan';

export function loadPlanState() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function savePlanState(state) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function clearPlanState() {
  localStorage.removeItem(STORAGE_KEY);
}
